












































import { defineComponent } from '@vue/composition-api';
import { APrimaryBtn, ASecondaryBtn } from '../../../base/app/buttons';

export default defineComponent({
  name: 'WarningModal',
  components: {
    APrimaryBtn,
    ASecondaryBtn
  },
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    value: {
      type: Boolean
    },
    labelCancel: {
      type: String,
      default: 'cancel'
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    labelConfirm: {
      type: String,
      default: 'yes'
    }
  },
  setup(_, { emit }) {
    const exit = () => {
      emit('confirm');
      emit('input', false);
    };
    return { exit };
  }
});
